class Feature {
  constructor(state) {
    this.state = state;
  }
  beforeMount() {
  }
  mount() {
  }
  unmount() {
  }
  update() {
  }
  beforeUpdate(options) {
  }
  beforeUnmount() {
  }
}
export {
  Feature
};
